var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileanalysisFlatline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406 306",
    style: {
      enableBackground: "new 0 0 406 306"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFEEAD;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#EBCA94;}\r\n\t.st4{fill:#D1D3D4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_95_profile_analysis"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180,266c-18.9,1-37.6,7.7-56.5,6.4c-35.3-2.5-64.2-33.4-72.2-68c-4.2-18-3.3-37.8,7.1-53 c3.8-5.6,8.8-10.4,12.7-15.8C83.6,118,84.4,94.2,96.1,75.9c13.8-21.3,39.5-30.9,64-37.2c14.4-3.7,28.8-6.8,43.5-9.2 c21.9-3.6,46.3-5.1,64.3,7.8c13.6,9.6,20.8,25.5,30.2,39.2c12.4,18.2,29.1,33.1,42.2,50.8c14.9,20,19.3,39,17,59.5l-0.2,1.8 c-1.4,9.3-3.7,18.5-7.1,27.4c-9.9,27.8-32.2,52.4-61.9,58.8C252.6,282.6,216.4,264.1,180,266z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 205.3,
    cy: 113.7,
    rx: 24.1,
    ry: 27.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.3,142.2c-13.6,0-24.6-12.8-24.6-28.4v-1.6c0-8.7,0-16.3,4.9-21.2c3.8-3.8,10.2-5.6,19.7-5.6 c9.5,0,16,1.8,19.7,5.6c5,5,5,12.5,4.9,21.2v1.6C229.9,129.5,218.9,142.2,205.3,142.2z M205.3,86.4c-9.2,0-15.4,1.7-18.9,5.3 c-4.7,4.7-4.6,12-4.6,20.5v1.6c0,15.1,10.6,27.5,23.6,27.5s23.6-12.3,23.6-27.5v-1.6c0-8.5,0-15.9-4.6-20.5 C220.7,88.1,214.5,86.4,205.3,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.2,230.3c0-17.5-7.3-48.3-13.1-55.7c-7.7-9.8-28.6-20.1-63.4-15c0,0-18,5.6-28.9,17.4 c-8.3,9.1-12.7,46.9-14.2,53.2H262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.6,127.3c-1.2-7.3-13.4-9.2-12.8-0.5c0.1,3,1.3,5.8,3.3,8.1c2.1,2.2,5.5,3.2,8.2,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.8,137.9c-2.3,0-4.5-1-6-2.6c-2.1-2.4-3.3-5.4-3.4-8.4c-0.3-4.3,2.3-6,4.8-6.3c3.8-0.4,8.3,2.2,9,6.6 c0.1,0.3-0.1,0.6-0.4,0.6l0,0c-0.3,0-0.6-0.2-0.6-0.4c-0.6-3.9-4.7-6.1-7.9-5.8c-1.3,0.1-4.2,0.9-3.9,5.2c0.1,2.9,1.2,5.6,3.1,7.8 c2,2.1,5,2.8,7.6,1.8c0.3-0.1,0.6,0,0.7,0.3c0.1,0.3,0,0.6-0.3,0.7C187.6,137.7,186.6,137.9,185.8,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,127.3c1.2-7.3,13.4-9.2,12.8-0.5c-0.1,3-1.3,5.8-3.3,8.1c-2.1,2.3-5.4,3-8.2,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.9,137.9c-1,0-1.9-0.2-2.8-0.6c-0.3-0.1-0.4-0.4-0.3-0.7c0.1-0.3,0.4-0.4,0.7-0.3h0.1 c2.7,1,5.6,0.3,7.6-1.8c1.9-2.2,3-5,3.1-7.8c0.3-4.3-2.6-5.1-3.9-5.2c-3.3-0.4-7.2,1.9-7.9,5.8c0,0.3-0.3,0.5-0.6,0.4 c-0.3-0.1-0.5-0.3-0.4-0.6c0.7-4.6,5.3-7.1,9-6.6c2.5,0.3,5.1,2.1,4.8,6.3c-0.1,3.2-1.3,6.1-3.4,8.4 C228.4,136.9,226.2,137.8,223.9,137.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "219,164.1 192.5,164.1 205,227  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205,227.5L205,227.5c-0.2,0-0.4-0.2-0.5-0.4L192,164.2c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.2H219 c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.3,0.1,0.4l-14,62.9C205.4,227.4,205.2,227.5,205,227.5z M193.1,164.6l11.9,60.1l13.4-60.1 L193.1,164.6L193.1,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.6,211.1l3.4,16l3.6-16c-0.9-12.1-1.8-33.6-1.8-33.6l1.6-3.5l-3-3l-3,3l2.2,3.8L201.6,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205,227.6L205,227.6c-0.2,0-0.5-0.2-0.5-0.4l-3.4-16c0-0.1,0-0.1,0-0.2l3-33.2l-2.1-3.6 c-0.1-0.2-0.1-0.5,0.1-0.6l3-3c0.1-0.1,0.2-0.2,0.4-0.2l0,0c0.1,0,0.3,0.1,0.4,0.2l3,3c0.2,0.2,0.2,0.4,0.1,0.6l-1.5,3.3 c0.1,1.8,0.9,22,1.8,33.5c0,0.1,0,0.1,0,0.2l-3.6,16C205.5,227.4,205.3,227.6,205,227.6L205,227.6z M202.1,211.1l2.9,13.5l3-13.6 c-0.9-11.9-1.8-33.3-1.8-33.6c0-0.1,0-0.2,0-0.2l1.4-3.1l-2.4-2.4l-2.4,2.4l2,3.4c0.1,0.1,0.1,0.2,0.1,0.3L202.1,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219,164.1c0,0-3.3,7.2-13,7.2c-5.5,0.2-10.6-2.6-13.6-7.2l0.4-5.2l1-12l0.9-11.2h22l0.7,9.1l0.2,3L219,164.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206,171.8c-5.6,0.1-11-2.7-14-7.4c-0.1-0.1-0.1-0.2-0.1-0.3l2.3-28.2c0-0.3,0.3-0.5,0.5-0.5h22 c0.3,0,0.5,0.2,0.5,0.5l2.3,28.2c0,0.1,0,0.2,0,0.3C219.5,164.4,215.9,171.8,206,171.8z M193,164c2.9,4.4,7.8,6.9,13,6.8 c8.5,0,11.9-5.8,12.4-6.7l-2.2-27.7h-21L193,164z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.2,144.1c-0.2,1.4-0.8,2.7-1.5,3.8c-1.9,2.7-4.4,4.9-7.2,6.3c-4.8,2.6-11.8,5.6-17.5,4.7l1-12 c4.2,0.5,8.4,0.6,12.7,0.1c3.7-0.3,7.5-0.7,10.9-2.1C218.1,144.7,218.7,144.4,219.2,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.1,159.6c-0.8,0-1.5-0.1-2.3-0.2c-0.3,0-0.5-0.3-0.4-0.5l1-12c0-0.1,0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.1,0.4-0.1c4.2,0.5,8.4,0.6,12.6,0.1c3.5-0.3,7.4-0.6,10.8-2.1c0.6-0.3,1.2-0.6,1.7-0.8c0.2-0.1,0.4-0.1,0.5,0 c0.2,0.1,0.2,0.3,0.2,0.5c-0.3,1.4-0.8,2.8-1.6,4.1c-1.9,2.8-4.5,5-7.4,6.5C207.2,156.7,200.9,159.6,195.1,159.6z M193.4,158.5 c5.9,0.7,13.1-2.6,16.7-4.7c2.9-1.4,5.3-3.6,7-6.1c0.5-0.8,0.9-1.7,1.2-2.6l-0.8,0.4c-3.6,1.5-7.5,1.9-11.1,2.2 c-4.1,0.5-8.2,0.5-12.3,0L193.4,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.4,149.8h-2c-9.3,0-16.8-7.5-16.8-16.8v-26.7h35.7V133C223.2,142.3,215.7,149.8,206.4,149.8L206.4,149.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.4,150.3h-2c-9.6,0-17.3-7.8-17.3-17.3v-26.7c0-0.3,0.2-0.5,0.5-0.5l0,0h35.8c0.3,0,0.5,0.2,0.5,0.5l0,0 V133C223.7,142.5,216,150.3,206.4,150.3z M188,106.8V133c0,9,7.3,16.4,16.4,16.4h2c9,0,16.4-7.3,16.4-16.4v-26.2H188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208,133c-0.9,0-1.7,0-2.6-0.1c-0.3,0-0.5-0.3-0.5-0.6s0.3-0.5,0.6-0.5c1.6,0.2,3.2,0.2,4.8,0 c0,0,0.1,0,0.1-0.1c0.7-1.2-1.2-7.6-2.8-11.8c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3c0.7,1.8,4,10.6,2.7,12.7 c-0.2,0.3-0.5,0.5-0.9,0.6C209.6,133,208.7,133,208,133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.2,142.7c-2.6,0-5.3-0.3-7.7-0.9c-0.3-0.1-0.5-0.4-0.4-0.6l0,0c0.1-0.3,0.3-0.4,0.6-0.4 c0.1,0,7.7,1.9,14,0c0.3-0.1,0.6,0.1,0.7,0.4c0.1,0.3-0.1,0.6-0.4,0.7C211.6,142.4,209.3,142.7,207.2,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.4,230.8h-228c-0.3,0-0.5-0.2-0.5-0.5V80.5c0-0.3,0.2-0.5,0.5-0.5h228c0.3,0,0.5,0.2,0.5,0.5v149.8 C316.9,230.6,316.6,230.8,316.4,230.8z M88.9,229.8h226.9V81H88.9V229.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.4,254.4h-228c-0.3,0-0.5-0.2-0.5-0.5v-23.6c0-0.3,0.2-0.5,0.5-0.5h228c0.3,0,0.5,0.2,0.5,0.5v23.6 C316.9,254.1,316.6,254.4,316.4,254.4z M88.9,253.4h226.9v-22.6H88.9V253.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 220.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -125.651 145.1043)",
    className: "st2",
    width: 62.7,
    height: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.8,249.5c-0.1,0-0.3-0.1-0.4-0.2l-5.3-5.3c-0.2-0.2-0.2-0.5,0-0.7l0,0l44.4-44.4c0.2-0.2,0.5-0.2,0.7,0l0,0 l5.3,5.3c0.2,0.2,0.2,0.5,0,0.7l-44.4,44.4C93.1,249.5,93,249.5,92.8,249.5z M88.2,243.8l4.6,4.6l43.7-43.7l-4.6-4.6L88.2,243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.2,219.6l1.9,1.9c2.2,2.2,2.2,5.8,0,8l-28.3,28.3c-2.2,2.2-5.8,2.2-8,0l-1.9-1.9c-2.2-2.2-2.2-5.8,0-8 l28.3-28.3C109.3,217.3,113,217.3,115.2,219.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 151.1,
    cy: 185.6,
    rx: 38.6,
    ry: 38.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.1,224.6c-21.6,0-39-17.4-39-39s17.4-39,39-39s39,17.4,39,39c0,10.4-4.2,20.3-11.4,27.7l-0.4-0.4l0.4,0.4 C171.4,220.6,161.5,224.6,151.1,224.6z M151.1,147.5c-21,0-38.1,17-38.1,38.1s17,38.1,38.1,38.1c10.1,0,19.8-4,27-11.2l0,0 c14.9-14.9,14.9-39,0-53.8C170.8,151.5,161.2,147.5,151.1,147.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 151.1,
    cy: 185.6,
    r: 32.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.1,218.2c-18,0-32.6-14.6-32.6-32.6S133,153,151.1,153s32.6,14.6,32.6,32.6c0,8.6-3.5,16.9-9.5,23.1l0,0 C168,214.7,159.7,218.2,151.1,218.2z M151.1,154c-17.4,0-31.6,14.2-31.6,31.6s14.2,31.6,31.6,31.6c8.4,0,16.5-3.4,22.4-9.3l0,0 c12.3-12.4,12.3-32.4-0.1-44.7C167.4,157.4,159.4,154,151.1,154L151.1,154z M173.9,208.3L173.9,208.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "278.6,142.3 278.6,151.1 260.8,151.1 278.6,161.9 278.6,206.3 356.7,206.3 356.7,142.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M356.7,206.8h-78.2c-0.3,0-0.5-0.2-0.5-0.5v-44l-17.5-10.7c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.3-0.4,0.5-0.4 h17.3v-8.3c0-0.3,0.2-0.5,0.5-0.5h78.2c0.3,0,0.5,0.2,0.5,0.5v64C357.2,206.6,357,206.8,356.7,206.8z M279.1,205.8h77.2v-62.9 h-77.2v8.3c0,0.3-0.2,0.5-0.5,0.5h-16.1l16.3,9.9c0.2,0.1,0.3,0.3,0.3,0.4L279.1,205.8L279.1,205.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "286.6,50.5 286.6,93.1 270.1,101 286.6,101 286.6,113.3 361.3,113.3 361.3,50.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M361.3,113.8h-74.8c-0.3,0-0.5-0.2-0.5-0.5v-11.9h-15.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.4,0.3-0.5 l16.1-7.7V50.5c0-0.3,0.2-0.5,0.5-0.5h74.7c0.3,0,0.5,0.2,0.5,0.5v62.8C361.8,113.6,361.6,113.8,361.3,113.8z M287,112.8h73.7V51 H287v42.1c0,0.2-0.1,0.4-0.3,0.5l-14.4,6.8h14.2c0.3,0,0.5,0.2,0.5,0.5V112.8z M286.5,93.1L286.5,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.5,46.5h-56.2v26.4h40.8l8.9,11.3V72.9h6.3L173.5,46.5L173.5,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167,84.7c-0.2,0-0.3-0.1-0.4-0.2l-8.8-11.2h-40.6c-0.3,0-0.5-0.2-0.5-0.5V46.5c0-0.3,0.2-0.5,0.5-0.5h56.2 c0.3,0,0.5,0.2,0.5,0.5v26.4c0,0.3-0.2,0.5-0.5,0.5h-5.8v10.8c0,0.2-0.1,0.4-0.3,0.5C167.2,84.7,167.1,84.7,167,84.7z M117.8,72.3 h40.3c0.2,0,0.3,0.1,0.4,0.2l8,10.2v-9.9c0-0.3,0.2-0.5,0.5-0.5h5.8V47h-55.1V72.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "132.1,107.3 117.4,107.3 117.4,96.4 44.7,96.4 44.7,143.1 117.4,143.1 117.4,114.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.4,143.6H44.7c-0.3,0-0.5-0.2-0.5-0.5V96.4c0-0.3,0.2-0.5,0.5-0.5h72.6c0.3,0,0.5,0.2,0.5,0.5v10.4h14.3 c0.2,0,0.4,0.2,0.5,0.4c0.1,0.2-0.1,0.5-0.3,0.6l-14.5,6.8v28.4C117.9,143.4,117.7,143.6,117.4,143.6z M45.2,142.6h71.7v-28.3 c0-0.2,0.1-0.4,0.3-0.5l12.7-5.9h-12.5c-0.3,0-0.5-0.2-0.5-0.5V96.9H45.2V142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.9,243.8v4.6h-4.8v-14.1h6c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.3,0.4,1.9,0.8c0.6,0.4,1,0.9,1.3,1.5 c0.4,0.7,0.5,1.5,0.5,2.3c0,0.8-0.1,1.6-0.5,2.3c-0.3,0.6-0.8,1.1-1.3,1.5c-0.6,0.4-1.2,0.7-1.9,0.8c-0.7,0.2-1.4,0.3-2.2,0.3 L164.9,243.8z M164.9,237.9v2.3h1c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.6,0.5-0.9c0-0.2,0-0.4-0.1-0.5c-0.1-0.1-0.2-0.3-0.3-0.3 c-0.1-0.1-0.3-0.1-0.5-0.2c-0.2,0-0.4,0-0.5-0.1H164.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M173.9,234.2h6c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.3,0.4,1.9,0.8c0.5,0.4,1,0.8,1.3,1.4c0.4,0.7,0.5,1.5,0.5,2.3 s-0.2,1.6-0.6,2.3c-0.5,0.7-1.1,1.2-1.8,1.5l3.6,5.7h-5.5l-2.7-5.1h-0.1v5.1h-4.6L173.9,234.2z M178.4,240.1h0.9c0.2,0,0.4,0,0.5,0 c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.6s0-0.4-0.1-0.6c-0.1-0.1-0.2-0.3-0.4-0.3 c-0.1-0.1-0.3-0.1-0.5-0.1h-0.5h-1.1L178.4,240.1L178.4,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M187.4,241.2c0-1,0.2-2.1,0.6-3c0.4-0.9,1-1.7,1.7-2.3c0.7-0.7,1.6-1.2,2.5-1.5c1-0.4,2.1-0.5,3.1-0.5 c1.1,0,2.1,0.2,3.1,0.5c0.9,0.3,1.8,0.8,2.5,1.5c0.7,0.7,1.3,1.5,1.7,2.3c0.4,1,0.6,2,0.6,3c0,1.1-0.2,2.1-0.6,3.1 c-0.4,0.9-1,1.7-1.7,2.4c-0.7,0.7-1.6,1.2-2.5,1.5c-1,0.4-2.1,0.6-3.1,0.5c-1.1,0-2.1-0.2-3.1-0.5c-0.9-0.3-1.8-0.9-2.5-1.5 c-0.7-0.7-1.3-1.5-1.7-2.4C187.6,243.3,187.4,242.2,187.4,241.2z M192.5,241.2c0,0.4,0.1,0.9,0.2,1.3c0.1,0.4,0.3,0.7,0.6,1 c0.2,0.3,0.5,0.5,0.9,0.7c0.4,0.2,0.7,0.2,1.1,0.2c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.3,0.5-0.6,0.6-1 s0.2-0.9,0.2-1.3s-0.1-0.8-0.2-1.2c-0.1-0.4-0.3-0.7-0.6-1c-0.3-0.3-0.6-0.5-0.9-0.6c-0.4-0.2-0.7-0.2-1.1-0.2 c-0.4,0-0.8,0.1-1.1,0.2s-0.6,0.3-0.9,0.6c-0.3,0.3-0.5,0.6-0.6,1C192.6,240.3,192.5,240.7,192.5,241.2L192.5,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M209.8,239.6h4.4v3.9h-4.3v4.8h-4.7v-14h9.5v4h-4.9L209.8,239.6L209.8,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M216.8,234.2h4.8v14.1h-4.8V234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.2,234.2h4.8v10h4.7v4.1h-9.5L224.2,234.2L224.2,234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.1,234.2h9.7v4h-5.3v1.2h5v3.7h-5v1.3h5.6v4h-10V234.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.4,194.2c-11.6,0-21-9.4-21-21s9.4-21,21-21s21,9.4,21,21C337.4,184.7,328,194.2,316.4,194.2L316.4,194.2z  M316.4,153.2c-11.1,0-20,9-20,20c0,11.1,9,20,20,20s20-9,20-20v-0.1C336.4,162.1,327.4,153.1,316.4,153.2L316.4,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M322.3,193.3c-0.2,0-0.4-0.1-0.5-0.4l-5.9-19.6c0-0.1,0-0.3,0.1-0.4l11.9-16.7c0.2-0.2,0.5-0.3,0.7-0.1l0,0 c0.2,0.2,0.3,0.5,0.1,0.7l-11.8,16.6l5.8,19.4C322.8,193,322.6,193.2,322.3,193.3L322.3,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.4,173.6c-0.1,0-0.2,0-0.2-0.1l-18.1-9.6c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l0,0l18.1,9.6 c0.2,0.1,0.3,0.4,0.2,0.7l0,0C316.7,173.5,316.5,173.6,316.4,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.1,136.5h-7.4c-0.3,0-0.5-0.2-0.5-0.5v-34c0-0.3,0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5v34 C69.6,136.3,69.4,136.5,69.1,136.5z M62.2,135.5h6.4v-33h-6.4V135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.3,136.5h-7.4c-0.3,0-0.5-0.2-0.5-0.5v-23.6c0-0.3,0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5V136 C85.8,136.3,85.6,136.5,85.3,136.5z M78.4,135.5h6.4V113h-6.3L78.4,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101.5,136.5h-7.4c-0.3,0-0.5-0.2-0.5-0.5V121c0-0.3,0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5V136 C102,136.3,101.8,136.5,101.5,136.5z M94.7,135.5h6.4v-14.1h-6.4V135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.7,136.5H54.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h53.2c0.3,0,0.5,0.2,0.5,0.5 C108.1,136.3,108,136.5,107.7,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351,164.6h-8.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h8.3c0.3,0,0.5,0.2,0.5,0.5 C351.5,164.4,351.3,164.6,351,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M351,169h-8.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h8.3c0.3,0,0.5,0.2,0.5,0.5 C351.5,168.8,351.3,169,351,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.7,173.6h-4.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h4.1c0.3,0,0.5,0.2,0.5,0.5 C347.2,173.4,347,173.6,346.7,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.2,186.6h-9.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h9.6c0.3,0,0.5,0.2,0.5,0.5 C295.7,186.3,295.4,186.6,295.2,186.6L295.2,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.8,190.4h-6.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.2c0.3,0,0.5,0.2,0.5,0.5 C292.2,190.2,292,190.4,291.8,190.4L291.8,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M298.9,92.4c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l16.7-12.9c0.2-0.2,0.5-0.1,0.7,0.1l9.6,10.9 l23.7-20.9c0.2-0.2,0.5-0.2,0.7,0l0,0c0.2,0.2,0.2,0.5,0,0.7l0,0l-24.2,21.3c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3-0.1-0.3-0.2 l-9.5-11l-16.4,12.6C299.2,92.3,299.1,92.4,298.9,92.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.9,96.7h-57.1c-0.3,0-0.5-0.2-0.5-0.5V63.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v32.4h56.6 c0.3,0,0.5,0.2,0.5,0.5S353.2,96.7,352.9,96.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321.8,63.8H301c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h20.8c0.3,0,0.5,0.2,0.5,0.5S322.1,63.8,321.8,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321.8,67.6H301c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h20.8c0.3,0,0.5,0.2,0.5,0.5 C322.3,67.4,322.1,67.6,321.8,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.7,71.4H301c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h9.7c0.3,0,0.5,0.2,0.5,0.5 C311.2,71.2,311,71.4,310.7,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133,70.3c-0.3,0-0.5-0.2-0.5-0.5V50.1c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v19.7 C133.5,70.1,133.2,70.3,133,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.6,54.1h-42.8c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h42.8c0.3,0,0.5,0.2,0.5,0.5 C166.1,53.9,165.9,54.1,165.6,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.6,60.4h-42.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h42.8c0.3,0,0.5,0.2,0.5,0.5 C166.1,60.2,165.9,60.4,165.6,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165.6,66.8h-42.8c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h42.8c0.3,0,0.5,0.2,0.5,0.5 C166.1,66.6,165.9,66.8,165.6,66.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 139.1,
    cy: 184.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 151.5,
    cy: 184.7,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 163.9,
    cy: 184.7,
    r: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileanalysisFlatline);
export default __webpack_public_path__ + "static/media/Profile analysis _Flatline.d1b38ab1f37418ac55cf988e14844108.svg";
export { ForwardRef as ReactComponent };